const $ = jQuery.noConflict();

'use strict';
const Accordion = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domAccShown: $('.js-box-shown'),
	$domAccHidden: $('.js-box-hidden'),
	classActive: 'is-active',

	/** @description Initialize */
	init: function() {
		this.accordion();
		const orderDetails = $('.order-status');
		orderDetails.each(function() {
			const textContent = $(this).text();
			if (textContent.includes('Processing')) {
				$(this).addClass('processing');
			} else if(textContent.includes('Completed')) {
				$(this).addClass('completed');
			} else if(textContent.includes('Cancelled')) {
				$(this).addClass('cancelled');
			} else if(textContent.includes('Failed')) {
				$(this).addClass('failed');
			} else if(textContent.includes('Pending payment')) {
				$(this).addClass('pending');
			} else if(textContent.includes('Refunded')) {
				$(this).addClass('refunded');
			} else if(textContent.includes('Shipping')) {
				$(this).addClass('shipping');
			} else if(textContent.includes('Shipped 1/3')) {
				$(this).addClass('shipping');
			} else if(textContent.includes('Shipped 2/3')) {
				$(this).addClass('shipping');
			} else if(textContent.includes('Shipped 3/3')) {
				$(this).addClass('shipping');
			} else if(textContent.includes('Delivered 1/3')) {
				$(this).addClass('completed-half');
			} else if(textContent.includes('Delivered 2/3')) {
				$(this).addClass('completed-half');
			} else if(textContent.includes('Delivered 3/3')) {
				$(this).addClass('completed');
			} else if(textContent.includes('Custom Order')) {
				$(this).addClass('custom');
			} else if(textContent.includes('Creating')) {
				$(this).addClass('creating');
			} else if(textContent.includes('On hold')) {
				$(this).addClass('hold');
			}
		});
		setTimeout(function() {
			$('.address_book').wrapAll('<div class="add-addresses__holder" />');
			$('<span class="form-pass-icon"></span>').appendTo($('.js-checkout-login-wrap .password-input'));
		}, 100);
		// $(document).ready(function() {
		// 	if (window.location.pathname.includes('/faq')) {
		// 		$('.accordion').addClass('single');
		// 	}
		// });
	},

	/** @description Bind Events */
	accordion: function() {
		Accordion.$domAccShown.each(function(e, el) {
			$(el).on('click', function() {
				const _self = $(this);
				if (_self.parent().hasClass(Accordion.classActive)) {
					_self.parent().removeClass(Accordion.classActive);
					_self.siblings(Accordion.$domAccHidden).slideUp();
				} else {
					_self.parent().addClass(Accordion.classActive);
					_self.siblings(Accordion.$domAccHidden).slideDown();
					_self.parent().siblings().removeClass(Accordion.classActive).find(Accordion.$domAccHidden).slideUp();
				}
			});
		});
	},
};

export default Accordion;